import { createSlice } from '@reduxjs/toolkit';
import { ICsaCoordination } from '../types';

const initialState: ICsaCoordination = {
  tasksForMe: {},
  requestedFieldSupport: {},
  isLoading: false,
  fieldSupportFilterSchema: {},
  tasksForMeFilterScehma: {}
};

const csaCoordinationSlice = createSlice({
  name: 'csaCoordination',
  initialState,
  reducers: {
    setTasksForMe: (state, action) => {
      state.tasksForMe = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setRequestedFieldSupport: (state, action) => {
      state.requestedFieldSupport = action.payload;
    },
    setFieldSupportFilterSchema: (state, action) => {
      state.fieldSupportFilterSchema = action.payload;
    },
    setTasksForMeFilterSchema: (state, action) => {
      state.tasksForMeFilterScehma = action.payload;
    }
  }
});

export const {
  setTasksForMe,
  setLoading,
  setRequestedFieldSupport,
  setFieldSupportFilterSchema,
  setTasksForMeFilterSchema
} = csaCoordinationSlice.actions;

export default csaCoordinationSlice.reducer;
